import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getPortfolioAnalysisBubbleChartData } from 'gqlQueries/portfolioAnalysis';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import _, { groupBy, uniq } from 'lodash';
import { bubbleChartDriverParser } from 'parser/portfolioAnalysisParser';
import { getUniqueKpiList } from 'parser/PortfolioBubbleChartParsar';

const errorMessage: string = 'Something went wrong!';
function useFetchPortfolioBubbleChart() {
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [kpiListData, setKpiListData] = useState([]);
    const [loading, setLoading] = useState(false);
    const { appConfig } = useContext(UserContext);
    const [group1, setGroupBy1] = useState('');
    const portfolioAnalysisConfig = getConfig('portfolioAnalysis', appConfig);

    const [fetchPortfolioBubbleChart] = useLazyQuery(getPortfolioAnalysisBubbleChartData, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPortfolioAnalysisBubbleChartData } = payload;
            //if data present parse it
            if (getPortfolioAnalysisBubbleChartData.length > 0) {
                setData(bubbleChartDriverParser(getPortfolioAnalysisBubbleChartData, group1));
                const uniqueKpiList: any = getUniqueKpiList(
                    getPortfolioAnalysisBubbleChartData,
                    portfolioAnalysisConfig,
                );
                //  setChartData(parsedChartData)
                setKpiListData(uniqueKpiList);

                return;
            }
            setData(null);
        } catch (error: any) {
            setData(null);
            setError(error);
            console.error(errorMessage, error, 'logging error');
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        console.log('logging error', error);
        //sending empty data to error to avoid null data being sent
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        error,
        data,
        loading,
        kpiListData,
        fetchPortfolioBubbleChart: (variables: any) => {
            setLoading(true);
            setGroupBy1(variables.variables.groupBy1);
            fetchPortfolioBubbleChart(variables);
        },
    };
}

export { useFetchPortfolioBubbleChart };
